




















import linkDirective from '@/shared/directives/link-directive';
import scrollPositionDirective from '@/shared/directives/scroll-position-directive';
import IContentItem from '../models/content-item';
import { defineComponent, onMounted, PropType, ref } from '@vue/composition-api';

    declare global {
        interface Window {
            dataLayer: any[]
        }
    }

    export default defineComponent({
        name: 'ContentItems',
        directives: {
            linkDirective,
            scrollPositionDirective
        },
        props: {
            items: { type: Array as PropType<IContentItem[]>, required: true }
        },
        setup() {
            const list = ref<HTMLElement | null>(null)
            const childElement = ref<HTMLElement | null>(null)

            onMounted(() => {
                if (list.value) {
                    childElement.value = list.value.lastChild as HTMLElement
                }

                if (window.dynamicColorSystem && typeof window.dynamicColorSystem.applyDynamicColors === 'function') {
                    window.dynamicColorSystem.applyDynamicColors()
                }
            })

            const trackTileSubSubClick = (item: IContentItem) => {
                const clickText = item.description
                const clickUrl = resolveUrl(item.url)
                pushDataLayerEvent('tile_sub_sub_click', clickText, clickUrl)
            }

            const resolveUrl = (url: string): string => {
                if (!url) {
                    return '';
                }
                return url.startsWith('http')
                    ? url
                    : `${window.location.origin}${url}`;
            };

            const pushDataLayerEvent = (event: string, clickText: string, clickUrl: string) => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event,
                    click_text: clickText,
                    click_url: clickUrl
                })
            }

            return {
                childElement,
                list,
                trackTileSubSubClick
            }
        }
    })
